import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd, AiOutlineDelete } from "react-icons/ai";
import { FiFilter, FiEdit } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { RiFilePaperLine } from "react-icons/ri";
import { BiCommentError } from "react-icons/bi";
import { ToastContainer } from "react-toastify";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import { getBeneficiries } from "../../store/actions/BenActions";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import changeMonthToText from "../../utils/ChangeMonthToText";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";
import { Insurances } from "../../utils/DataSource";
import {
  getAssocciationMembers,
  addAssocciationMember,
  updateAssocciationMembers,
  deleteAssocciationMembers,
} from "../../store/actions/AssocciationMembersActions";
import ContentLoader from "react-content-loader";
import DownloadBtn from "../../components/DownloadBtn";

import {
  getAssocciationsById,
  updateAssocciation,
  deleteAssocciation,
} from "../../store/actions/AssocciationsActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useHistory, Link } from "react-router-dom";
import { currentDate } from "../../utils/currentDate";

function ViewAssocciation() {
  const dispatch = useDispatch();
  const members = useSelector((state) => state.assocciationMembers);
  const beneficiaries = useSelector((state) => state.beneficiries);
  const assocciations = useSelector(
    (state) => state.stateOfAssociations.assocciation
  );
  const loaders = useSelector((state) => state.loadersState);

  const beneficiaryStatus = [
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "Left",
      value: "LEFT",
    },
  ];

  const [member, setMember] = useState({
    id: "",
    beneficiaryId: "",
    memberName: "",
    startDate: "",
    endDate: "",
    status: "",
    associationId: "",
  });

  const { assocciationid } = useParams();
  const selectedAssocc = assocciationid;
  const [openUpperTab, setOpenUpperTab] = useState(1);
  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    setMember({
      id: "",
      beneficiaryId: "",
      memberName: "",
      startDate: "",
      endDate: "",
      status: "",
      associationId: "",
    });
  }

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedMember) {
    setEditBeneOverlay(!editBenOverlay);
    setMember({
      id: passedMember.id,
      beneficiaryId: passedMember.beneficiaryId,
      memberName: passedMember.memberName,
      startDate: passedMember.startDate,
      endDate: passedMember.endDate,
      status: passedMember.stat,
    });
  }

  const [editAssocciation, setEditAssocciation] = useState(0);
  function editAssocciationController(passedAssocciation) {
    setEditAssocciation(!editAssocciation);
    setAssocciation({
      id: passedAssocciation.id,
      name: passedAssocciation.name,
      purpose: passedAssocciation.purpose,
      description: passedAssocciation.description,
      venue: passedAssocciation.venue,
    });
  }
  const [addAssocciation, setAddAssocciation] = useState(0);
  function AddAssocciationController() {
    setAddAssocciation(!addAssocciation);
  }
  const [filterAssocciationOverlay, setFilterAssocciationOverlay] = useState(0);
  function AssocciationFilterOverlayController() {
    setFilterAssocciationOverlay(!filterAssocciationOverlay);
  }

  // for insurance table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "Member",
        accessor: "memberName",
      },
      {
        Header: "JoiningDate",
        accessor: "startDate",
      },
      {
        Header: "LeavingDate",
        accessor: "endDate",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );
  const assocciationsInfo = assocciations;

  // filter matching members
  const assocciationsMembers = members.filter(
    (member) => member.association.id === assocciations.id
  );

  // transform assocciation data
  let [loadedAssocciationMembers, setLoadedAssocciationMember] = useState([]);

  useEffect(() => {
    setLoadedAssocciationMember([]);
    for (let i = 0; i < assocciationsMembers.length; i++) {
      const member = {
        count: i + 1,
        id: assocciationsMembers[i].id,
        beneficiary: `${assocciationsMembers[i].beneficiary.firstName}  ${assocciationsMembers[i].beneficiary.lastName}`,
        beneficiaryId: assocciationsMembers[i].beneficiary.id,
        startDate: changeMonthToText(assocciationsMembers[i].startDate),
        endDate: changeMonthToText(assocciationsMembers[i].endDate),
        memberName: assocciationsMembers[i].memberName,
        stat: assocciationsMembers[i].status,
        status: (
          <div className="py-1 px-2 rounded   font-normal fit-content">
            {capitalizeFirstLetter(assocciationsMembers[i].status)}
          </div>
        ),
        action: (
          <Action
            editAction={() => {
              editOverlayController(member);
            }}
            deleteAction={() => {
              handleDelete(members[i].id);
            }}
          />
        ),
      };

      setLoadedAssocciationMember((loadedAssocciationMembers) => [
        ...loadedAssocciationMembers,
        member,
      ]);
      if (
        loaders.assocciationMembers.deletingAction &&
        loaders.assocciationMembers.deletingAction.deleting
      ) {
        const currentAssoccMembers = loadedAssocciationMembers;
        const newData = currentAssoccMembers.map((member) =>
          member.id === loaders.assocciationMembers.deletingAction.id
            ? {
              ...member,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : member
        );
        setLoadedAssocciationMember(newData);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [members, loaders.assocciationMembers.deletingAction]);

  let [loadingAssocciationMember, setLoadingAssocciationMember] = useState([]);

  useEffect(() => {
    setLoadingAssocciationMember([]);
    for (let i = 0; i < 5; i++) {
      const member = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        startDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        memberName: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        endDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingAssocciationMember((loadingAssocciationMember) => [
        ...loadingAssocciationMember,
        member,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.assocciationMembers.fetchingLoaders]);

  // reload beneficiries
  useEffect(() => {
    dispatch(getAssocciationMembers());        

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }

  // assocciation info
  const [assocciation, setAssocciation] = useState({
    id: "",
    name: "",
    purpose: "",
    description: "",
    venue: "",
  });
  // reload beneficiries
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let history = useHistory();
  // handle delete
  const handleDeleteAssocciation = (id) => {
    dispatch(deleteAssocciation(id, redirectAfterDelete));
  };

  function redirectAfterDelete() {
    history.push("/assocciations");
  }

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteAssocciationMembers(id));
  };

  // handle member submit
  const handleMemberSubmit = (e) => {
    e.preventDefault();
    if (member.id) {
      const id = member.id;
      const updatedMember = {
        id: member.id,
        beneficiaryId: member.beneficiaryId,
        associationId: selectedAssocc,
        status: member.status,
        startDate: member.startDate,
        endDate: member.endDate,
      };
      dispatch(
        updateAssocciationMembers(updatedMember, id, closeMemberAfterUpdating)
      );
    } else {
      const newMember = {
        ...member,
        associationId: selectedAssocc,
      };
      dispatch(addAssocciationMember(newMember, closeMemberFormAfterAdding));
    }
  };
  // handle assocciation update
  const handleAssocciationUpdate = (e) => {
    e.preventDefault();
    const id = assocciation.id;
    const updatedAssocciation = {
      id: assocciation.id,
      name: assocciation.name,
      purpose: assocciation.purpose,
      description: assocciation.description,
      venue: assocciation.venue,
    };
    dispatch(
      updateAssocciation(
        updatedAssocciation,
        id,
        closeAssocciationAfterUpdating
      )
    );
  };
  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === member.beneficiaryId
  );
  // reload beneficiries
  useEffect(() => {
    dispatch(getAssocciationsById(selectedAssocc));    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // closing member after cu
  function closeMemberFormAfterAdding() {
    benOverlayController();
    setMember({
      id: "",
      beneficiaryId: "",
      memberName: "",
      startDate: "",
      endDate: "",
      status: "",
      associationId: "",
    });
  }

  function closeMemberAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryId: "",
      memberName: "",
      startDate: "",
      endDate: "",
      status: "",
      associationId: "",
    });
  }
  // closing member after u

  function closeAssocciationAfterUpdating() {
    editAssocciationController({
      id: "",
      name: "",
      purpose: "",
      description: "",
      venue: "",
    });
  }

  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      {(!loaders.assocciation.loadingOne && !assocciationsInfo.id) |
        loaders.assocciation.loadingOneFailedMsg ? (
        <div
          className={
            !loaders.assocciation.loadingOneFailedMsg
              ? "bg-white mx-10 h-60 flex  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold"
              : "bg-red-100 mx-10 h-60 flex text-xs rounded  text-center py-2 px-4 text-red-500 font-semibold"
          }
        >
          <div className="m-auto">
            {!loaders.assocciation.loadingOneFailedMsg ? (
              <div className="flex-col">
                <RiFilePaperLine className="text-3xl mx-auto my-3" />{" "}
                <p>This assocciation is not found</p>{" "}
              </div>
            ) : (
              <div className="flex-col">
                <BiCommentError className="text-3xl mx-auto my-3" />{" "}
                <p>{loaders.assocciation.loadingOneFailedMsg}</p>{" "}
              </div>
            )}
          </div>
        </div>
      ) : loaders.assocciation.loadingOne ? (
        <div className="bg-white mx-10 h-60 flex">
          <div className="spinner m-auto indigo-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      ) : (
        <div className="bg-white mx-10">
          <div className="flex flex-col md:flex-row p-10 pl-10 pb-0">
            <h2 className="font-semibold">
              <Link
                to="/associations"
                className="hover:text-indigo-500 text-indigo-300"
              >
                Assocciation {">"}
              </Link>{" "}
              <span className="font-normal">{assocciationsInfo.name}</span>
            </h2>
            <div className="md:m-auto mt-2 md:mr-0">
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? benOverlayController()
                    : AddAssocciationController();
                }}
              >
                <AiOutlineUserAdd />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                }
                onClick={() => {
                  editAssocciationController(assocciationsInfo);
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-red-500 border border-red-500 hover:bg-red-100"
                }
                onClick={() => {
                  handleDeleteAssocciation(selectedAssocc);
                }}
              >
                <AiOutlineDelete
                  className={
                    loaders.assocciation.deletingAction &&
                      loaders.assocciation.deletingAction.deleting
                      ? " refresh-loader"
                      : " "
                  }
                />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? filterOverlayController()
                    : AssocciationFilterOverlayController();
                }}
              >
                <FiFilter />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  dispatch(getAssocciationMembers());
                }}
              >
                <FcRefresh
                  className={
                    loaders.assocciationMembers.fetchingLoaders
                      ? " refresh-loader"
                      : " "
                  }
                />
              </button>

              <DownloadBtn
                filename={`${assocciations.name}-${changeMonthToText(currentDate())}`} table="table-to-xls"
              />
            </div>
          </div>
          {/* insurance tabs */}
          <div className="flex mt-2 flex-wrap">
            <div className="w-full">
              <ul
                className="flex mb-0 list-none flex-wrap  font-medium  flex-row w-full"
                role="tablist"
              >
                <li className="-mb-px  last:mr-0 ml-10">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0   block leading-normal" +
                      (openUpperTab === 1
                        ? " text-white bg-indigo-500 rounded rounded-r-none border-b-2 border-" +
                          color +
                          "-500"
                        : " text-indigo-50 bg-indigo-400 border-b-2 rounded rounded-r-none border-indigo-400")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(1);
                    }}
                    data-toggle="tab"
                    href="#link1"
                    role="tablist"
                  >
                    <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                    Members
                  </a>
                </li>
                <li className="-mb-px  last:mr-0">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0  block leading-normal " +
                      (openUpperTab === 2
                        ? "text-white bg-indigo-500  border-b-2 border-" +
                          color +
                          "-500"
                        : "text-indigo-50 bg-indigo-400  border-b-2 border-indigo-400")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(2);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    <i className="fas fa-cog text-base mr-1"></i> Information
                  </a>
                </li>
                <li className="-mb-px  last:mr-0">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0  block leading-normal " +
                      (openUpperTab === 3
                        ? "text-white bg-indigo-500  border-b-2 border-" +
                          color +
                          "-500"
                        : "text-indigo-50 bg-indigo-400  border-b-2 border-indigo-400")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(3);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    <i className="fas fa-cog text-base mr-1"></i> Assets
                  </a>
                </li>
                <li className="-mb-px  last:mr-0">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0  block leading-normal " +
                      (openUpperTab === 4
                        ? "text-white bg-indigo-500 rounded rounded-l-none border-b-2 border-" +
                          color +
                          "-500"
                        : "text-indigo-50 bg-indigo-400 rounded rounded-l-none border-b-2 border-indigo-400")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(4);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    <i className="fas fa-cog text-base mr-1"></i>Report
                  </a>
                </li>
              </ul>
              <div className="relative flex flex-col min-w-0 break-words w-full mb-2">
                <div>
                  <div className="tab-content tab-space">
                    <div
                      className={
                        openUpperTab === 1 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full">
                        {/* insurance table */}
                        <div className="w-full">
                          {(!loaders.assocciationMembers.fetchingLoaders &&
                            assocciationsMembers.length < 1) |
                            loaders.assocciationMembers.fetchFailedMessage ? (
                            <div
                              className={
                                !loaders.assocciationMembers.fetchFailedMessage
                                  ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                  : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                              }
                            >
                              <p className="m-auto">
                                {!loaders.assocciationMembers.fetchFailedMessage
                                  ? "No members record found"
                                  : loaders.assocciationMembers
                                    .fetchFailedMessage}
                              </p>
                            </div>
                          ) : (
                            <Table
                              data={
                                loaders.assocciationMembers.fetchingLoaders
                                  ? loadingAssocciationMember
                                  : loadedAssocciationMembers
                              }
                              columns={columns}
                            />
                          )}{" "}
                        </div>
                      </div>
                    </div>
                    {/* Assocciations table */}
                    <div
                      className={
                        openUpperTab === 2 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 flex flex-wrap  w-full">
                        {/* Academics table */}
                        <div className="w-full flex flex-col my-3 ml-10 mr-10 border">
                          <div className="flex flex-col md:flex-row border-b p-5">
                            <div className="font-semibold md:w-2/12">
                              Target
                            </div>
                            <div>{assocciationsInfo.purpose}</div>
                          </div>
                          <div className="flex flex-col md:flex-row border-b p-5">
                            <div className="font-semibold md:w-2/12">
                              Description
                            </div>
                            <div className="text-justify md:w-8/12">
                              {assocciationsInfo.description}
                            </div>
                          </div>
                          {/* <div className="flex flex-col md:flex-row border-b p-5">
                          <div className="font-semibold mr-2">Member share</div>
                          <div className="text-justify md:w-8/12 m-auto ml-0">
                            {assocciationsInfo.share}%
                          </div>
                        </div> */}
                          <div className="flex flex-col md:flex-row border-b p-5">
                            <div className="font-semibold md:w-2/12">
                              Working site
                            </div>
                            <div className="text-justify w-8/12">
                              {assocciationsInfo.venue}
                            </div>
                          </div>
                          {/* <div className="flex flex-col md:flex-row border-b p-5">
                          <div className="font-semibold md:w-2/12">
                            Projects
                          </div>
                          <div className="text-justify md:w-8/12">
                            <ul className="list-disc">
                              {selectedAssocciation.projects.map(
                                (project, i) => {
                                  return <li key={i}>{project.title}</li>;
                                }
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="flex flex-col md:flex-row  p-5">
                          <div className="font-semibold md:w-2/12">Economy</div>
                          <div className="text-justify md:w-8/12">
                            <ul className="list-disc">
                              {selectedAssocciation.property.map(
                                (property, i) => {
                                  return <li key={i}>{property.name}</li>;
                                }
                              )}
                            </ul>
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end.... */}
          {/*add insurance overlay  */}
          <div
            className={
              addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
            }
          >
            <Overlay>
              <div className=" bg-white m-auto  rounded">
                <div
                  className={
                    loaders.assocciationMembers.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.assocciationMembers.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {addBenOverlay
                        ? "Register member"
                        : "Change member information"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addBenOverlay
                            ? benOverlayController()
                            : editOverlayController({
                              id: "",
                            });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <form
                    className="flex flex-wrap"
                    onSubmit={handleMemberSubmit}
                  >
                    <div className="w-full">
                      <div className="flex flex-col pt-3">
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Beneficiary Id</label>
                          <Select
                            options={beneficiriesOption}
                            value={beneficiriesOption.find(
                              (obj) => obj.value === member.beneficiaryId
                            )}
                            onChange={(e) =>
                              setMember({
                                ...member,
                                beneficiaryId: e.value,
                              })
                            }
                          />
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Name</label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={
                                member.beneficiaryId
                                  ? selectedBeneficiary[0].name
                                  : ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Member name</label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={member.memberName}
                              onChange={(e) =>
                                setMember({
                                  ...member,
                                  memberName: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2  w-full">
                          <div className="flex w-full">
                            <div>
                              <label>Joining Date</label>

                              <div className={style.field.parentDiv + " w-1/2"}>
                                <input
                                  type="date"
                                  className={style.field.input}
                                  value={member.startDate}
                                  onChange={(e) =>
                                    setMember({
                                      ...member,
                                      startDate: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <div className="ml-auto">
                              <label>Leaving Date</label>

                              <div className={style.field.parentDiv + " w-1/2"}>
                                <input
                                  type="date"
                                  className={style.field.input}
                                  value={member.endDate}
                                  onChange={(e) =>
                                    setMember({
                                      ...member,
                                      endDate: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {/*  field */}
                          <div className="py-2  w-full">
                            <label>Status </label>
                            <Select
                              options={beneficiaryStatus}
                              value={beneficiriesOption.find(
                                (obj) => obj.value === member.status
                              )}
                              onChange={(e) =>
                                setMember({
                                  ...member,
                                  status: e.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        {/* save btn */}
                        <button
                          type="submit"
                          className={style.loginBtn}
                          disabled={loaders.assocciationMembers.sendingLoader}
                        >
                          {!loaders.assocciationMembers.sendingLoader ? (
                            <p className="m-auto">
                              {addBenOverlay ? "Save" : "Update"}
                            </p>
                          ) : (
                            <div className="spinner m-auto">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Overlay>
          </div>
          {/*edit Assocciation overlay  */}
          <div
            className={
              addAssocciation || editAssocciation ? "flex w-screen" : "hidden"
            }
          >
            <Overlay>
              <div className="bg-white m-auto  rounded">
                <div
                  className={
                    loaders.assocciation.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.assocciation.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {"Change info on assocciation"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addAssocciation
                            ? AddAssocciationController()
                            : editAssocciationController({
                              id: "",
                            });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <form
                    className="flex flex-wrap"
                    onSubmit={handleAssocciationUpdate}
                  >
                    <div className="w-full">
                      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                        <div>
                          <div className="flex flex-col pt-3">
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Name </label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="text"
                                  className={style.field.input}
                                  value={assocciation.name}
                                  onChange={(e) =>
                                    setAssocciation({
                                      ...assocciation,
                                      name: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Target </label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="text"
                                  className={style.field.input}
                                  value={assocciation.purpose}
                                  onChange={(e) =>
                                    setAssocciation({
                                      ...assocciation,
                                      purpose: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Description </label>
                              <div className={style.field.parentDiv}>
                                <textarea
                                  className={style.field.input}
                                  value={assocciation.description}
                                  onChange={(e) =>
                                    setAssocciation({
                                      ...assocciation,
                                      description: e.target.value,
                                    })
                                  }
                                ></textarea>
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Working site</label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="text"
                                  className={style.field.input}
                                  value={assocciation.venue}
                                  onChange={(e) =>
                                    setAssocciation({
                                      ...assocciation,
                                      venue: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>

                            {/* save btn */}
                            <button
                              type="submit"
                              className={style.loginBtn}
                              disabled={loaders.assocciation.sendingLoader}
                            >
                              {!loaders.assocciation.sendingLoader ? (
                                <p className="m-auto">{"Save"}</p>
                              ) : (
                                <div className="spinner m-auto">
                                  <div className="bounce1"></div>
                                  <div className="bounce2"></div>
                                  <div className="bounce3"></div>
                                </div>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Overlay>
          </div>
          {/* filter insurance  overlay */}
          <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="p-10 bg-white m-auto  rounded">
                <div className="flex">
                  <h2 className="font-semibold">{"Filter members"}</h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        filterOverlayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-col pt-3">
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Beneficiary range</label>
                    <div className="flex w-full">
                      <Select options={beneficiaries} className="w-1/2 mr-2" />

                      <Select options={beneficiaries} className="w-1/2" />
                    </div>{" "}
                  </div>
                  {/*  field */}
                  <div className="py-2  w-full">
                    <label>Stati </label>
                    <Select options={Insurances} isMulti />
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>JoiningDate range </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>LeavingDate range </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>
                  {/* save btn */}
                  <button type="submit" className={style.loginBtn}>
                    <p className="m-auto">{"Apply"}</p>
                  </button>
                </div>
              </div>
            </Overlay>
          </div>
        </div>
      )}

      <table className="table text-left table-to-export hidden" id="table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Member</th>
            <th>Joining date</th>
            <th>Leaving date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {assocciationsMembers.map((assocMember) =>
            <tr>            
              <td> {assocMember.beneficiary.firstName} {assocMember.beneficiary.lastName}{" "}</td>
              <td>{assocMember.memberName}</td>
              <td>{changeFromTimeStamp(assocMember.startDate)}</td>
              <td>{changeFromTimeStamp(assocMember.endDate)}</td>
              <td>{assocMember.status}</td>
            </tr>
          )}

        </tbody>
      </table>
    </DashLayout>
  );
}

export default ViewAssocciation;
